import React from 'react';
import { useNavigate } from 'react-router-dom';

const PendingApproval = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="container-fluid" style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div className="row justify-content-center w-100">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-lg border-0" style={{ borderRadius: '20px' }}>
            <div className="card-body text-center p-5">
              <div className="mb-4">
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  background: 'linear-gradient(45deg, #ffd700, #ffed4e)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto',
                  boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)'
                }}>
                  <i className="fas fa-clock" style={{ fontSize: '2rem', color: '#fff' }}></i>
                </div>
              </div>

              <h2 className="card-title mb-3" style={{ color: '#2c3e50', fontWeight: 'bold' }}>
                ⏳ Revisión en Proceso
              </h2>

              <div className="card-text mb-4" style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
                <p className="mb-3">
                  Tu solicitud de acceso al sistema está siendo revisada por nuestros administradores.
                </p>
                <p className="mb-3">
                  <strong>¿Qué sucede ahora?</strong>
                </p>
                <ul className="text-start" style={{ listStyle: 'none', padding: 0 }}>
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    Recibimos tu solicitud correctamente
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-clock text-warning me-2"></i>
                    Un administrador la revisará pronto
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-bell text-info me-2"></i>
                    Te notificaremos cuando sea aprobada
                  </li>
                </ul>
              </div>

              <div className="alert alert-info" style={{ 
                background: 'linear-gradient(45deg, #e3f2fd, #bbdefb)',
                border: 'none',
                borderRadius: '15px'
              }}>
                <i className="fas fa-info-circle me-2"></i>
                <strong>Proceso típico:</strong> 24-48 horas
              </div>

              <div className="d-grid gap-2">
                <button
                  onClick={handleLogout}
                  className="btn btn-outline-secondary"
                  style={{
                    borderRadius: '25px',
                    padding: '12px 30px',
                    border: '2px solid #95a5a6',
                    color: '#7f8c8d',
                    fontWeight: '600',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = '#95a5a6';
                    e.target.style.color = '#fff';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#7f8c8d';
                  }}
                >
                  <i className="fas fa-sign-out-alt me-2"></i>
                  Cerrar Sesión
                </button>
              </div>

              <div className="mt-4">
                <small style={{ color: '#bdc3c7' }}>
                  ¿Tienes preguntas? Contacta a soporte técnico
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
